<template>
  <header class="mdl-layout__header">
    <div class="mdl-layout__header-row">
        <!-- Title -->
        <span class="mdl-layout-title">The API IO</span>
        <!-- Add spacer, to align navigation to the right -->
        <div class="mdl-layout-spacer"></div>
        <!-- Navigation -->
        <nav class="mdl-navigation">
          <router-link class="mdl-navigation__link" to="/register" v-if="!authenticated">Signup</router-link>
          <router-link class="mdl-navigation__link" to="/signin" v-if="!authenticated">Sign In</router-link>
          <a class="mdl-navigation__link" href="" v-if="authenticated" @click="signout">Sign Out</a>
        </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'NavTop',
  computed: {
    authenticated () {
      return this.$store.state.user.authenticated
    }
  },
  methods: {
    signout: async function () {
      try {
        await this.$store.dispatch('signout')
        this.$router.push('/')
      } catch (e) {
        alert('Error Signing Out!')
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/NavTop.vue